import { render, staticRenderFns } from "./DeleteStageActionWarningModal.vue?vue&type=template&id=2fb155a7&scoped=true&"
import script from "./DeleteStageActionWarningModal.vue?vue&type=script&lang=js&"
export * from "./DeleteStageActionWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStageActionWarningModal.vue?vue&type=style&index=0&id=2fb155a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb155a7",
  null
  
)

export default component.exports